var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFleche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 46,
    height: 50,
    transform: "translate(312 345.752)",
    fill: "#2b2b2b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fleche",
    transform: "translate(-345.752 358) rotate(-90)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_40",
    "data-name": "Layer 40",
    transform: "translate(312 350.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_562",
    "data-name": "Trac\\xE9 562",
    d: "M89.165,129.751a34.575,34.575,0,0,0-34.557,34.586l-7.29-7.282a1.532,1.532,0,0,0-2.162,2.167l9.9,9.893a1.534,1.534,0,0,0,2.169,0l9.9-9.893a1.533,1.533,0,0,0-2.169-2.167l-7.29,7.282a31.511,31.511,0,0,1,31.491-31.523,1.531,1.531,0,1,0,0-3.063Z",
    transform: "translate(-44.757 -129.751)",
    fill: "#2b2b2b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFleche);
export default __webpack_public_path__ + "static/media/ico_fleche.0e20d376d6d5f3095edee5dda273f8a9.svg";
export { ForwardRef as ReactComponent };